import { Text } from '@dixa/lib-shared-habla';

import type { WaitAutomationActivity } from '../types/automationActivity';

type RoutedThroughWaitProps = {
  node: WaitAutomationActivity;
};

export function RoutedThroughWait({
  node,
}: RoutedThroughWaitProps): JSX.Element {
  return (
    <Text.Paragraph>
      Wait · {`Automation waited for ${node.delayInSeconds} seconds`}
    </Text.Paragraph>
  );
}
